module.exports = __webpack_public_path__ + "static/media/requete_normale.5f010849.mp3";